import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Stack, Alert } from '@mui/material';

const ProfileSettings = ({ user, onUpdate }) => {
  const [username, setUsername] = useState(user?.user?.username || '');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleUpdate = async (e) => {
    e.preventDefault();
    setMessage(null);
    if (password && password !== confirm) {
      setMessage({ type: 'error', text: 'Passwords do not match.' });
      return;
    }
    setLoading(true);
    try {
      // Call backend API to update user info
      const res = await fetch('/api/users/profile', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.token}`,
        },
        body: JSON.stringify({ username, password: password || undefined }),
      });
      const data = await res.json();
      if (res.ok) {
        setMessage({ type: 'success', text: 'Profile updated.' });
        if (onUpdate) onUpdate({ ...user, user: { ...user.user, username } });
      } else {
        setMessage({ type: 'error', text: data.error || 'Update failed.' });
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'Update failed.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleUpdate} sx={{ maxWidth: 400 }}>
      <Stack spacing={2}>
        <TextField
          label="Username"
          value={username}
          onChange={e => setUsername(e.target.value)}
          fullWidth
        />
        <TextField
          label="New Password"
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          fullWidth
        />
        <TextField
          label="Confirm Password"
          type="password"
          value={confirm}
          onChange={e => setConfirm(e.target.value)}
          fullWidth
        />
        <Button type="submit" variant="contained" disabled={loading}>
          Save Changes
        </Button>
        {message && <Alert severity={message.type}>{message.text}</Alert>}
      </Stack>
    </Box>
  );
};

export default ProfileSettings;
